import React from 'react'
import AuthLogo from './auth_logo.svg'
import { usePath } from '@resultadosdigitais/front-hub/react'
import styled from 'styled-components/macro'
import Form from '../Form'
import { useTranslation } from 'react-i18next'
import { Link } from '@resultadosdigitais/tangram-components'

const StyledForm = styled(Form)`
  width: 480px;
`

const Image = styled.img`
  height: 100% !important;
  width: 100% !important;
`

const Title = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  font-family: Nunito Sans;
  font-weight: bold;
  line-height: 130%;
`

const Small = styled.div`
  font-size: 12px;
  color: #636e7c;
`

const Big = styled.div`
  font-size: 28px;
  color: #212429;
`

const MessageBody = styled.div`
  font-family: Nunito Sans;
  font-size: 16px;
  line-height: 150%;
`

const MessageInfo = styled.div`
  color: #212429;
  margin: 32px 0px;
`

const StyledLink = styled.div`
  color: #11a7b6;
  font-weight: bold;
  margin: 16px 0px;
`

export default function MFAMessageSuccess({ showLogin }) {
  const { t } = useTranslation()
  const assetPath = usePath()

  return (
    <StyledForm>
      <div>
        <Image src={assetPath(AuthLogo)} alt={t('MFAMessageSuccess.Acessibility.MFASuccesAlt')} />
      </div>
      <Title>
        <Small>{t('MFAMessageSuccess.TitleSmall')}</Small>
        <Big>{t('MFAMessageSuccess.TitleBig')}</Big>
      </Title>
      <MessageBody>
        <MessageInfo>
          {t('MFAMessageSuccess.Message')} <strong>{t('MFAMessageSuccess.Warning')}</strong>
        </MessageInfo>
        <StyledLink>
          <Link onClick={showLogin}> {t('MFAMessageSuccess.ResendLink')}</Link>
        </StyledLink>
      </MessageBody>
    </StyledForm>
  )
}
